const footerLinks = [
  {
    title: '快速导航',
    items: [
      { label: '平台优势', href: '#features' },
      { label: '热门话题', href: '#topics' },
      { label: '精选推荐', href: '#cards' },
      { label: '热度榜单', href: '#ranking' },
    ],
  },
  {
    title: '帮助中心',
    items: [
      { label: '常见问题', href: '#faq' },
      { label: '联系我们', href: '#contact' },
      { label: '关于我们', href: '#about' },
      { label: '最新动态', href: '#updates' },
    ],
  },
  {
    title: '合作伙伴',
    items: [],
  },
];

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50">
                苹果视频
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              苹果视频汇集海量高清电影、电视剧资源，涵盖西瓜视频免费、免费视频网站91等热门频道，全高清流畅播放零缓冲，免费在线观看，每日更新最新影视内容。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-100 mb-4">
                {group.title}
              </h4>
              {group.items.length > 0 ? (
                <ul className="space-y-3">
                  {group.items.map((item) => (
                    <li key={item.label}>
                      <a
                        href={item.href}
                        onClick={(e) => { e.preventDefault(); handleClick(item.href); }}
                        className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                      >
                        {item.label}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-background-500">暂无合作伙伴信息</p>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 苹果视频 - 免费高清电影电视剧在线观看平台
          </p>
          <p className="text-xs text-background-600">
            本站内容仅供学习交流，不存储任何视频文件
          </p>
        </div>
      </div>
    </footer>
  );
}